import styled from '@emotion/styled';
import { StaticImage } from 'gatsby-plugin-image';
import piza from '../images/1-homepage/homepage-6-pisa.png';
import React, { useState } from 'react';

export const OurOutstandingStaffStyled = styled.section`
    color: ${({ theme }) => theme.colors.yellow3};
    margin-bottom: 80px;

    h2 {
        text-align: center;
        margin-bottom: 24px;
    }
    button {
        margin-top: 32px;
        width: 100%;
    }
    .image-container {
        display: flex;
        gap: 16px;
        flex-wrap: wrap;
        justify-content: center;
        margin-bottom: 24px;
        span {
            margin-bottom: 32px;
            font-family: 'Poppins';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 150%;
            margin-top: -12px;
            color: #929ea4;
        }
        > div {
            display: flex;
            flex-direction: column;
            align-items: center;
            p {
                margin-top: 16px;
                color: ${({ theme }) => theme.colors.gray5};
                font-weight: 700;
                font-size: 16px;
                line-height: 24px;
            }
        }
        div > div {
            border-radius: 15px;
            flex-shrink: 0;
            img {
                border-radius: 15px;
            }
        }
    }
    @media ${({ theme }) => theme.device.tablet} {
        .image-container {
            margin-bottom: 48px;
            max-width: 600px;
            margin: 0 auto;
        }
        h2 {
            margin-bottom: 32px;
        }
    }
    @media ${({ theme }) => theme.device.laptop} {
        background: linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)),
            url(${piza});
        padding-bottom: 120px;
        background-size: 60%;
        background-repeat: no-repeat;
        background-position: 500px -10px;
        margin-bottom: 0;
        .image-container {
            gap: 24px;
            padding: 0 30px;
            margin-bottom: 48px;
            max-width: 100%;
            margin: auto;
        }
        button {
            width: 211px;
            margin: 64px auto;
        }
    }
`;

interface Props {
    homepage?: boolean;
}

export const OurOutstandingStaff: React.FC<Props> = ({ homepage }) => {
    const [silly, setSilly] = useState(false);

    setTimeout(() => {
        setSilly(silly => !silly);
    }, 5000);
    return (
        <OurOutstandingStaffStyled className="container">
            <h2 className="alt-staff header-2">At Santa Clarita office, you will meet:</h2>

            <div className="image-container">
                <div>
                    <StaticImage
                        placeholder="blurred"
                        src="../images/staff/yadira.jpg"
                        alt="Yadira"
                        quality={80}
                        width={221}
                        height={221}
                    />
                    <p>Yadira</p>
                </div>
                <div>
                    {silly ? (
                        <StaticImage
                            placeholder="blurred"
                            src="../images/staff/nicole.jpg"
                            alt="Nicole"
                            quality={80}
                            width={221}
                            height={221}
                        />
                    ) : (
                        <StaticImage
                            placeholder="blurred"
                            src="../images/staff/nicole-fun.jpg"
                            alt="Nicole"
                            quality={80}
                            width={221}
                            height={221}
                        />
                    )}
                    <p>Nicole</p>
                </div>
                <div>
                    <StaticImage
                        placeholder="blurred"
                        src="../images/1-homepage/homepage-6-kimberly.jpg"
                        alt="Kimberly"
                        quality={80}
                        width={221}
                        height={221}
                    />
                    <p>Kimberly</p>
                </div>
                <div>
                    {silly ? (
                        <StaticImage
                            placeholder="blurred"
                            src="../images/staff/crystal.jpeg"
                            alt="Crystal"
                            quality={80}
                            width={221}
                            height={221}
                        />
                    ) : (
                        <StaticImage
                            placeholder="blurred"
                            src="../images/staff/crystal-fun.jpeg"
                            alt="Crystal"
                            quality={80}
                            width={221}
                            height={221}
                        />
                    )}
                    <p>Crystal</p>
                </div>
                <div>
                    {silly ? (
                        <StaticImage
                            placeholder="blurred"
                            src="../images/staff/chrizel.jpg"
                            alt="Chrizel"
                            quality={80}
                            width={221}
                            height={221}
                        />
                    ) : (
                        <StaticImage
                            placeholder="blurred"
                            src="../images/staff/chrizel-fun.jpg"
                            alt="Chrizel"
                            quality={80}
                            width={221}
                            height={221}
                        />
                    )}
                    <p>Chrizel</p>
                </div>
                <div>
                    {silly ? (
                        <StaticImage
                            placeholder="blurred"
                            src="../images/staff/sonia.jpg"
                            alt="Sonia"
                            quality={80}
                            width={221}
                            height={221}
                        />
                    ) : (
                        <StaticImage
                            placeholder="blurred"
                            src="../images/staff/sonia-fun.jpg"
                            alt="Sonia"
                            quality={80}
                            width={221}
                            height={221}
                        />
                    )}
                    <p>Sonia</p>
                </div>
                <div>
                    {silly ? (
                        <StaticImage
                            placeholder="blurred"
                            src="../images/staff/rochelle.jpg"
                            alt="Rochelle"
                            quality={80}
                            width={221}
                            height={221}
                        />
                    ) : (
                        <StaticImage
                            placeholder="blurred"
                            src="../images/staff/rochelle-fun.jpg"
                            alt="Rochelle"
                            quality={80}
                            width={221}
                            height={221}
                        />
                    )}
                    <p>Rochelle</p>
                </div>
                <div>
                    <StaticImage
                        placeholder="blurred"
                        src="../images/staff/jackie.jpg"
                        alt="Jackie"
                        quality={80}
                        width={221}
                        height={221}
                    />
                    <p>Jackie</p>
                </div>
                <div>
                    <StaticImage
                        placeholder="blurred"
                        src="../images/staff/erika.jpg"
                        alt="Erika Davenport"
                        quality={80}
                        width={221}
                        height={221}
                    />
                    <p>Erika</p>
                </div>
            </div>

            <>
                <h2 style={{ marginTop: '32px' }} className="alt-staff header-2">
                    At Porter Ranch office, you will meet:
                </h2>
                <div className="image-container">
                    <div>
                        {silly ? (
                            <StaticImage
                                placeholder="blurred"
                                src="../images/staff/carina.jpg"
                                alt="Carina"
                                quality={80}
                                width={221}
                                height={221}
                            />
                        ) : (
                            <StaticImage
                                placeholder="blurred"
                                src="../images/staff/carina-fun.jpg"
                                alt="Carina"
                                quality={80}
                                width={221}
                                height={221}
                            />
                        )}
                        <p>Carina (KiKI)</p>
                        <span>Office Manager</span>
                    </div>
                    <div>
                        {silly ? (
                            <StaticImage
                                placeholder="blurred"
                                src="../images/staff/alicia.jpg"
                                alt="Alicia"
                                quality={80}
                                width={221}
                                height={221}
                            />
                        ) : (
                            <StaticImage
                                placeholder="blurred"
                                src="../images/staff/alicia-fun.jpg"
                                alt="Alicia"
                                quality={80}
                                width={221}
                                height={221}
                            />
                        )}

                        <p>Alicia (Rainbow)</p>
                        <span>Supervisor/RDAEF2</span>
                    </div>
                    <div>
                        {silly ? (
                            <StaticImage
                                placeholder="blurred"
                                src="../images/staff/antonio.jpg"
                                alt="Antonio"
                                quality={80}
                                width={221}
                                height={221}
                            />
                        ) : (
                            <StaticImage
                                placeholder="blurred"
                                src="../images/staff/antonio-fun.jpg"
                                alt="Antonio"
                                quality={80}
                                width={221}
                                height={221}
                            />
                        )}
                        <p>Antonio (DJ Prophy)</p>
                        <span>Registered Dental Assistant</span>
                    </div>
                    <div>
                        <StaticImage
                            placeholder="blurred"
                            src="../images/staff/gwen.jpg"
                            alt="Antonio"
                            quality={80}
                            width={221}
                            height={221}
                        />
                        <p>Gwen</p>
                        <span>Registered Dental Assistant</span>
                    </div>

                    <div>
                        <StaticImage
                            placeholder="blurred"
                            src="../images/staff/cindy.jpg"
                            alt="Antonio"
                            quality={80}
                            width={221}
                            height={221}
                        />
                        <p>Cindy</p>
                        <span>Receptionist</span>
                    </div>
                </div>{' '}
            </>
        </OurOutstandingStaffStyled>
    );
};
